import { Project, PageModel, Designer } from '@brg/api';
import { createSlice } from '@reduxjs/toolkit';

export const getOstbay = (p: Project) => {
    const r = p as any
    return r?.additionalInfo?.isOstbay
}

type ProjectStatusItem = {
    likes: string;
    isBookmarked: boolean;
}

type ProjectLikesItem = {
    isLiked: boolean,
    likes: number,
    anonymousLikes: number,
    items: Designer[],
    itemsLikes: [],
    isNoLikes: boolean,
    likeWeight: number,
    views: number,
    quCount?: number,
    itemsLikesPaging: {
        page: number,
        offset: number,
        limit: number,
        count: number,
        pages: number
    },
}

interface IContextState  {
    project: Project;
    projectStatus: {
        [key: string]: ProjectStatusItem
    }
    likes: {
        [key: string]: ProjectLikesItem
    }
    showOriginals?: boolean,
    isOstbay?: boolean
}

export const CurrentProjectSlice = createSlice({
    name: 'contextList',
    initialState: {
        project: null,
        projectStatus: {},
        likes: {},
        isOstbay: false,
        itemsLikesPaging: {
            page: 1,
            offset: 0,
            limit: 0,
            count: 0,
            pages: 1
        },
        showOriginals: false
    },
    reducers: {
        setIsOstBay: (state, action) => {
            state.isOstbay = action.payload
        },
        setBookmarked: (state, { payload }) => {
            const { id, status } = payload;
            state.projectStatus = {
                ...state.projectStatus,
                [id]: {
                    //@ts-ignore
                    ...state.projectStatus?.[id],
                    isBookmarked: status,
                },
            };
        },
        setIsReposted: (state, { payload }) => {
            const { id, status } = payload;
            state.projectStatus = {
                ...state.projectStatus,
                [id]: {
                    //@ts-ignore
                    ...state.projectStatus?.[id],
                    isReposted: status,
                },
            };
        },
        setLikesField: (state, { payload }) => {
            const { id, field, value } = payload;
            state.likes = {
                ...state.likes,
                [id]: {
                    //@ts-ignore
                    ...state.likes?.[id],
                    [field]: value,
                },
            };
        },
        setOriginalsState: (state, { payload }) => {
            const { value } = payload;
            state.showOriginals = value;
        }
    }
});

export default CurrentProjectSlice
export const CurrentProjectActions = CurrentProjectSlice.actions
export const CurrentProjectSelector = (store: { currentProject: IContextState }): IContextState => store.currentProject;
import { Project, PageModel, Designer } from '@brg/api';
import { createSlice } from '@reduxjs/toolkit';

export const getOstbay = (p: Project) => {
    const r = p as any
    return r?.additionalInfo?.isOstbay
}

type ProjectStatusItem = {
    likes: string;
    isBookmarked: boolean;
}

type ProjectLikesItem = {
    isLiked: boolean,
    likes: number,
    anonymousLikes: number,
    items: Designer[],
    itemsLikes: [],
    isNoLikes: boolean,
    likeWeight: number,
    views: number,
    quCount?: number,
    itemsLikesPaging: {
        page: number,
        offset: number,
        limit: number,
        count: number,
        pages: number
    },
}

interface IContextState  {
    project: Project;
    projectStatus: {
        [key: string]: ProjectStatusItem
    }
    likes: {
        [key: string]: ProjectLikesItem
    }
    showOriginals?: boolean,
    isOstbay?: boolean
}

export const CurrentProjectSlice = createSlice({
    name: 'contextList',
    initialState: {
        project: null,
        projectStatus: {},
        likes: {},
        isOstbay: false,
        itemsLikesPaging: {
            page: 1,
            offset: 0,
            limit: 0,
            count: 0,
            pages: 1
        },
        showOriginals: false
    },
    reducers: {
        setIsOstBay: (state, action) => {
            state.isOstbay = action.payload
        },
        setBookmarked: (state, { payload }) => {
            const { id, status } = payload;
            state.projectStatus = {
                ...state.projectStatus,
                [id]: {
                    //@ts-ignore
                    ...state.projectStatus?.[id],
                    isBookmarked: status,
                },
            };
        },
        setIsReposted: (state, { payload }) => {
            const { id, status } = payload;
            state.projectStatus = {
                ...state.projectStatus,
                [id]: {
                    //@ts-ignore
                    ...state.projectStatus?.[id],
                    isReposted: status,
                },
            };
        },
        setLikesField: (state, { payload }) => {
            const { id, field, value } = payload;
            state.likes = {
                ...state.likes,
                [id]: {
                    //@ts-ignore
                    ...state.likes?.[id],
                    [field]: value,
                },
            };
        },
        setOriginalsState: (state, { payload }) => {
            const { value } = payload;
            state.showOriginals = value;
        }
    }
});

export default CurrentProjectSlice
export const CurrentProjectActions = CurrentProjectSlice.actions
export const CurrentProjectSelector = (store: { currentProject: IContextState }): IContextState => store.currentProject;
